import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { PublicPageNotFound } from './App';
import Dialer from './Dialer';
import { LocaleProvider } from './i18n';
import {
  Routes,
  Route,
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";
import { resolveProductSurface } from './landing/landingRoute';

const LandingPage = lazy(() => import('./landing/LandingPage'));

function LandingFallback() {
  return <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f4f4ed', color: '#193524' }}><BcallLoadingMark /></main>;
}

function BcallLoadingMark() {
  return <span aria-label="Bcall" style={{ width: 44, height: 44, borderRadius: '50%', border: '5px solid #dce9d3', borderTopColor: '#8bc34a', animation: 'caller-spin 800ms linear infinite' }} />;
}

function ProductRoutes() {
  const location = useLocation();
  const surface = resolveProductSurface(window.location.hostname, location.pathname);
  return (
    <Routes>
      <Route path='/dialer' element={surface === 'dialer' ? <Dialer /> : <PublicPageNotFound />} />
      <Route path='*' element={surface === 'landing'
        ? <Suspense fallback={<LandingFallback />}><LandingPage /></Suspense>
        : surface === 'unavailable' ? <PublicPageNotFound /> : <App />}
      />
    </Routes>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Note: StrictMode removed to prevent double-mounting which interferes with SIP connections
root.render(
  <LocaleProvider>
    <Router>
      <ProductRoutes />
    </Router>
  </LocaleProvider>
);
